// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a2a716bf","592":"6d7de513","672":"090e7e92"}[chunkId] + ".chunk.js";
};